import { render, staticRenderFns } from "./ProOnlyAlertBox.vue?vue&type=template&id=9752c9ca&"
import script from "./ProOnlyAlertBox.vue?vue&type=script&lang=ts&"
export * from "./ProOnlyAlertBox.vue?vue&type=script&lang=ts&"
import style0 from "./ProOnlyAlertBox.vue?vue&type=style&index=0&id=9752c9ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports